import React, { useState } from 'react';
import { connect } from 'react-redux';
import BtnSubmit from '../../../../Shared/Buttons/BtnSubmit';
import TextInput from '../../../../Shared/TextInput/TextInput';
import CheckBox from '../../../../Shared/CheckBox/Checkbox';
import RadioInput from '../../../../Shared/RadioInput/RadioInput';
import { getAdminNvOrgListAsync } from '../../BusinessMonitoringChartsAsyncThunk';

const AdminSearch = (props) => {
    const [formData, setFormData] = useState({
        searchKey: { value: '', error: '' },
        ban: { value: false },
        nv: { value: true },
    });

    return (
        <div className='admin-search-container'>
            <form noValidate id='admin-search' onSubmit={(e)=> e.preventDefault()}>
                <TextInput
                    value={formData.searchKey.value}
                    error={formData.searchKey.error}
                    placeholder='הכנס מספר לקוח'
                    id='searchKey'
                    name='searchKey'
                    type='text'
                    maxLength='40'
                    autoComplete='off'
                    onChange={(e) => onChangeSearchKey(e.target.value)}
                />
                <div className='radio-wrapper'>
                    <RadioInput
                        checked={formData.ban.value}
                        label={'מספר Ban'}
                        name='searchType'
                        value={'ban'}
                        id='ban'                        
                        onChange={(e) => { onChangeType('ban'); }}
                    />                    
                </div>
                <div className='radio-wrapper'>
                    <RadioInput
                        checked={formData.nv.value}
                        label={'קוד קו/NV'}
                        name='searchType'
                        value={'nv'}
                        id='nv'                        
                        onChange={(e) => { onChangeType('nv'); }}
                    /> 
                </div>                                                
                <BtnSubmit text={'הצג נתונים'} onclick={handleSearchClick} formid='admin-search' />            
            </form>
        </div>
    );


    function onChangeSearchKey(value) {
        formData['searchKey'].value = value;
        if (value) {
            formData['searchKey'].error = '';
        }
        else {
            formData['searchKey'].error = 'נא הזן ערך לחיפוש';
        }
        setFormData({ ...formData });
    }   
    

    function onChangeType(fieldName) {
        switch (fieldName) {
            case 'ban':
                formData['ban'].value = true;
                formData['nv'].value = false;
                break;
            case 'nv':
                formData['nv'].value = true;
                formData['ban'].value = false;
                break;
        }        
        setFormData({ ...formData });
    }    


    function handleSearchClick() {
        if (!formData.searchKey.value) {
            formData['searchKey'].error = 'נא הזן ערך לחיפוש';
            setFormData({ ...formData });
            return;
        }
        
        const searchType = formData.ban.value ? 'ban': 'nv';
        props.getAdminNvOrgListAsync({ searchKey: formData.searchKey.value, searchType: searchType });
    }

}

const mapStateToProps = (state) => {
    return {
        
    };
};
  
const mapDispatchToProps = { getAdminNvOrgListAsync };
  
export default connect(mapStateToProps, mapDispatchToProps)(AdminSearch);